import PageMainTitle from 'components/commons/PageMainTitle'
import Message from 'components/about/Message'
import Profile from 'components/about/Profile'
import History from 'components/about/History'
import BoardMembers from '../BoardMembers'
import styles from './About.module.scss'
import Recruit from 'components/home/Recruit'
import Column from 'components/home/Column'
import { pageMainTitle } from 'components/about/About/AboutItems'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const About: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'About', url: '#' },
  ]
  return (
    <>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
      <Message />
      <div style={{ backgroundColor: '#f5f5f5' }}>
        <BoardMembers />
      </div>
      <Profile />
      <div style={{ backgroundColor: '#f5f5f5' }}>
        <History />
      </div>
      <div className={styles.recruit}>
        <Recruit tagType="h2" />
      </div>
      <div className={styles.column}>
        <Column tagType="h2" />
      </div>
      {/*
      <CaseStudy tagType="h2" />
      */}
      <MailmagazineLink />
    </>
  )
}

export default About
